export enum ViewType {
  Dispersion = 'dispersion',
  Trajectory = 'trajectory',
  Optimizer = 'optimizer',
  ClubData = 'clubData',
  Video = 'video',
  Summary = 'summary',
  SkidAndRoll = 'skidAndRoll',
  NotSpecified = '',
}

export function GetViewType(s: string): ViewType {
  switch (s.toLowerCase()) {
    case 'dispersion':
      return ViewType.Dispersion;
    case 'trajectory':
      return ViewType.Trajectory;
    case 'optimizer':
      return ViewType.Optimizer;
    case 'clubData':
      return ViewType.ClubData;
    case 'video':
      return ViewType.Video;
    case 'summary':
      return ViewType.Summary;
    case 'skidandroll':
      return ViewType.SkidAndRoll;
    default:
      return ViewType.NotSpecified;
  }
}
